import styled from '@emotion/styled';
import { bindPopover, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import profile from '../../../assets/icons/menu/profile.svg';
import { AuthContext } from '../../../contexts/AuthContext';
import { FrontMenuPopupWrapperItem, MenuIcon, MenuItem, NavTitle } from '../helpers/styled';
import { useSidebarStore } from '../store/store';
import { CollapsedSubMenu } from './CollapsedSubMenu';

export const MyAccount = () => {
  const { collapsed } = useSidebarStore();
  const { apiUser, setLogOut } = useContext(AuthContext);

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'myAccount',
  });

  return (
    <>
      <MenuItem $isCollapsed={collapsed} {...bindTrigger(popupState)}>
        <MenuIcon $src={profile} />
        {!collapsed && <NavTitle> My Account</NavTitle>}
      </MenuItem>
      <CollapsedSubMenu
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <NavLinkStyled to={'/brand'} onClick={popupState.close}>
          <FrontMenuPopupWrapperItem>Switch Brands</FrontMenuPopupWrapperItem>
        </NavLinkStyled>
        {apiUser.organizationid === 401 &&
          (apiUser.role === 'Admin' || apiUser.role === 'Manager') && (
            <NavLinkStyled to={'/brand'} onClick={popupState.close}>
              <FrontMenuPopupWrapperItem>Invite Client</FrontMenuPopupWrapperItem>
            </NavLinkStyled>
          )}
        <FrontMenuPopupWrapperItem
          onClick={() => {
            popupState.close();
            setLogOut();
          }}
          $dangerous
        >
          Logout
        </FrontMenuPopupWrapperItem>
      </CollapsedSubMenu>
    </>
  );
};

const NavLinkStyled = styled(NavLink)`
  &:hover {
    text-decoration: none;
  }
`;
